import { onMounted as xe, nextTick as _e, getCurrentScope as Le, onScopeDispose as We, unref as E, getCurrentInstance as Ee, ref as T, watch as J, computed as C, defineComponent as Ge, toRef as oe, onUnmounted as ke, openBlock as Be, createElementBlock as $e, normalizeClass as je, normalizeStyle as Ie, createElementVNode as Ce, renderSlot as Re } from "vue";
function Me(n) {
  return Le() ? (We(n), !0) : !1;
}
function be(n) {
  return typeof n == "function" ? n() : E(n);
}
const pe = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Fe = (n) => n != null, Ze = Object.prototype.toString, qe = (n) => Ze.call(n) === "[object Object]", Ve = () => {
};
function Ke(n) {
  return n || Ee();
}
function Ue(n, o = !0, a) {
  Ke() ? xe(n, a) : o ? n() : _e(n);
}
function ae(n) {
  var o;
  const a = be(n);
  return (o = a == null ? void 0 : a.$el) != null ? o : a;
}
const Pe = pe ? window : void 0;
pe && window.document;
pe && window.navigator;
pe && window.location;
function Te(...n) {
  let o, a, e, i;
  if (typeof n[0] == "string" || Array.isArray(n[0]) ? ([a, e, i] = n, o = Pe) : [o, a, e, i] = n, !o)
    return Ve;
  Array.isArray(a) || (a = [a]), Array.isArray(e) || (e = [e]);
  const r = [], d = () => {
    r.forEach((l) => l()), r.length = 0;
  }, u = (l, f, w, x) => (l.addEventListener(f, w, x), () => l.removeEventListener(f, w, x)), c = J(
    () => [ae(o), be(i)],
    ([l, f]) => {
      if (d(), !l)
        return;
      const w = qe(f) ? { ...f } : f;
      r.push(
        ...a.flatMap((x) => e.map((R) => u(l, x, R, w)))
      );
    },
    { immediate: !0, flush: "post" }
  ), h = () => {
    c(), d();
  };
  return Me(h), h;
}
function Je() {
  const n = T(!1), o = Ee();
  return o && xe(() => {
    n.value = !0;
  }, o), n;
}
function Se(n) {
  const o = Je();
  return C(() => (o.value, Boolean(n())));
}
function Qe(n, o, a = {}) {
  const { window: e = Pe, ...i } = a;
  let r;
  const d = Se(() => e && "MutationObserver" in e), u = () => {
    r && (r.disconnect(), r = void 0);
  }, c = C(() => {
    const w = be(n), x = (Array.isArray(w) ? w : [w]).map(ae).filter(Fe);
    return new Set(x);
  }), h = J(
    () => c.value,
    (w) => {
      u(), d.value && e && w.size && (r = new MutationObserver(o), w.forEach((x) => r.observe(x, i)));
    },
    { immediate: !0, flush: "post" }
  ), l = () => r == null ? void 0 : r.takeRecords(), f = () => {
    u(), h();
  };
  return Me(f), {
    isSupported: d,
    stop: f,
    takeRecords: l
  };
}
function He(n, o, a = {}) {
  const { window: e = Pe, ...i } = a;
  let r;
  const d = Se(() => e && "ResizeObserver" in e), u = () => {
    r && (r.disconnect(), r = void 0);
  }, c = C(() => Array.isArray(n) ? n.map((f) => ae(f)) : [ae(n)]), h = J(
    c,
    (f) => {
      if (u(), d.value && e) {
        r = new ResizeObserver(o);
        for (const w of f)
          w && r.observe(w, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), l = () => {
    u(), h();
  };
  return Me(l), {
    isSupported: d,
    stop: l
  };
}
function Ne(n, o = {}) {
  const {
    reset: a = !0,
    windowResize: e = !0,
    windowScroll: i = !0,
    immediate: r = !0
  } = o, d = T(0), u = T(0), c = T(0), h = T(0), l = T(0), f = T(0), w = T(0), x = T(0);
  function R() {
    const m = ae(n);
    if (!m) {
      a && (d.value = 0, u.value = 0, c.value = 0, h.value = 0, l.value = 0, f.value = 0, w.value = 0, x.value = 0);
      return;
    }
    const y = m.getBoundingClientRect();
    d.value = y.height, u.value = y.bottom, c.value = y.left, h.value = y.right, l.value = y.top, f.value = y.width, w.value = y.x, x.value = y.y;
  }
  return He(n, R), J(() => ae(n), (m) => !m && R()), Qe(n, R, {
    attributeFilter: ["style", "class"]
  }), i && Te("scroll", R, { capture: !0, passive: !0 }), e && Te("resize", R, { passive: !0 }), Ue(() => {
    r && R();
  }), {
    height: d,
    bottom: u,
    left: c,
    right: h,
    top: l,
    width: f,
    x: w,
    y: x,
    update: R
  };
}
function De(n) {
  return n * 180 / Math.PI;
}
function Ae(n) {
  return n * Math.PI / 180;
}
function le(n, o, a) {
  return Math.min(Math.max(n, o), a);
}
function Ye(n, o) {
  return Math.atan2(o[1] - n[1], o[0] - n[0]);
}
function fe(n, o, a) {
  const [e, i] = n, [r, d] = o, u = Math.cos(a) * (e - r) - Math.sin(a) * (i - d) + r, c = Math.sin(a) * (e - r) + Math.cos(a) * (i - d) + d;
  return [u, c];
}
function de(n, o) {
  const a = Math.pow(10, o);
  return Math.round(n * a) / a;
}
function et({
  wrapperInnerWidth: n,
  wrapperInnerHeight: o,
  canvasNaturalWidth: a,
  canvasNaturalHeight: e,
  translate: i,
  rotate: r,
  scale: d,
  offset: u,
  rotationEnabled: c,
  minScale: h,
  maxScale: l,
  naturalScale: f,
  clientCoordsToWrapperCoords: w,
  getCanvasCoords: x,
  calcProjectionTranslate: R
}) {
  let m = null, y = [0, 0];
  const j = (g) => Array.from(g).map((M) => {
    const b = w(M.clientX, M.clientY);
    return {
      client: [M.clientX, M.clientY],
      canvasRel: x(b[0], b[1])
    };
  });
  return {
    handleTouchstart: (g) => {
      g.target.closest(".matrix") === null && (g.preventDefault(), m = j(g.touches), d.value, y = [i.value[0], i.value[1]], r.value);
    },
    handleTouchmove: (g) => {
      if (g.target.closest(".matrix") !== null)
        return;
      g.preventDefault();
      const b = Array.from(g.touches).map((_) => w(_.clientX, _.clientY));
      if (m)
        if (b.length >= 2 && m.length >= 2) {
          const _ = [
            m[0].canvasRel[0] * a.value,
            m[0].canvasRel[1] * e.value
          ], O = [
            m[1].canvasRel[0] * a.value,
            m[1].canvasRel[1] * e.value
          ], z = Math.sqrt(
            Math.pow(_[0] - O[0], 2) + Math.pow(_[1] - O[1], 2)
          ), H = Math.sqrt(
            Math.pow(b[0][0] - b[1][0], 2) + Math.pow(b[0][1] - b[1][1], 2)
          ) / f.value, D = le(H / z, h.value, l.value), A = [
            b[0][0] / n.value,
            b[0][1] / o.value
          ], V = m[0].canvasRel, [I, K] = R(D, A, V, 0);
          let W = 0, N = 0, G = 0;
          if (c.value) {
            let k = function(te, re) {
              return [
                u.value.left + a.value * te * f.value * D + I,
                u.value.top + e.value * re * f.value * D + K
              ];
            };
            const ee = Ye(_, O);
            G = Ye(
              b[0],
              b[1]
            ) - ee, console.log("startAngle", ee);
            const U = k(0, 0), B = k(
              m[0].canvasRel[0],
              m[0].canvasRel[1]
            ), Z = fe(
              U,
              B,
              G
            );
            W = Z[0] - U[0], N = Z[1] - U[1];
          }
          d.value = D, r.value = G, i.value = [I + W, K + N], console.log("scale", d.value), console.log("rotate", r.value), console.log("translate", i.value[0], i.value[1]);
        } else {
          const _ = g.touches[0].clientX - m[0].client[0], O = g.touches[0].clientY - m[0].client[1], z = [y[0] + _, y[1] + O];
          i.value = z;
        }
    },
    handleTouchend: (g) => {
      g.target.closest(".matrix") === null && (g.touches.length === 0 ? m = null : (m = j(g.touches), d.value, y = [i.value[0], i.value[1]], r.value));
    }
  };
}
function Oe(n) {
  var o = !1;
  return n.wheelDeltaY ? n.wheelDeltaY === n.deltaY * -3 && (o = !0) : n.deltaMode === 0 && (o = !0), o;
}
function Xe(n, o) {
  const a = o.find((e) => n % e === 0);
  return a ? n / a : 1;
}
function tt({
  scale: n,
  translate: o,
  minScale: a,
  maxScale: e,
  relativeWrapperCoordinatesFromClientCoords: i,
  normalizeMatrixCoordinates: r,
  calcProjectionTranslate: d
}) {
  function u(c) {
    let { deltaX: h, deltaY: l, ctrlKey: f } = c;
    const w = [120, 100], x = 2;
    Oe(c) || ((Math.abs(h) === 120 || Math.abs(h) === 200) && (h = h / (100 / x * Xe(h, w)) * Math.sign(h)), (Math.abs(l) === 120 || Math.abs(l) === 200) && (l = l / (100 / x * Xe(l, w)) * Math.sign(l)));
    const R = n.value;
    if (f) {
      const m = -l / 100 * R, y = le(R + m, a.value, e.value), [j, Q] = d(
        y,
        i(c.clientX, c.clientY),
        r(c.clientX, c.clientY)
      );
      o.value = [j, Q], n.value = y;
    } else
      o.value = [o.value[0] - h, o.value[1] - l];
    c.preventDefault(), c.stopPropagation();
  }
  return {
    handleWheel: u
  };
}
function nt(n) {
  let o = null, a = null, e = null;
  return {
    handleMousedown: (u) => {
      u.preventDefault(), o = [u.clientX, u.clientY], a = n.value[0], e = n.value[1];
    },
    handleMouseup: (u) => {
      u.preventDefault(), o = null, a = null, e = null;
    },
    handleMousemove: (u) => {
      if (u.preventDefault(), o && a !== null && e !== null) {
        const c = u.clientX - o[0], h = u.clientY - o[1], l = a - -c, f = e - -h;
        n.value = [l, f];
      }
    }
  };
}
function ot(n, o, a, e) {
  let i = 0;
  return {
    handleGesturestart: (c) => {
      i = n.value;
    },
    handleGesturechange: (c) => {
      if (o.value === !1)
        return;
      const h = c.rotation;
      if (h === 0)
        return;
      const l = e(c.clientX, c.clientY);
      a(l[0], l[1], i + Ae(h));
    },
    handleGestureend: (c) => {
    }
  };
}
function at({
  wrapperElementRef: n,
  canvasNaturalWidth: o,
  canvasNaturalHeight: a,
  offset: e,
  bounds: i,
  rotationEnabled: r,
  minScale: d,
  maxScale: u
}) {
  const { x: c, y: h, width: l, height: f } = Ne(n), w = C(() => ({
    x: c.value,
    y: h.value,
    width: l.value,
    height: f.value
  })), x = C(() => c.value + e.value.left), R = C(() => h.value + e.value.top), m = C(() => l.value - e.value.left - e.value.right), y = C(() => f.value - e.value.top - e.value.bottom), j = C(() => m.value / y.value), Q = C(() => o.value / a.value), S = C(() => Q.value >= j.value ? m.value / o.value : y.value / a.value), Y = (() => {
    const t = T(0), s = T(0);
    return C({
      get() {
        return [t.value, s.value];
      },
      set([p, v]) {
        const P = o.value * b.value - m.value, X = a.value * b.value - y.value;
        if (r.value || !i.value)
          t.value = p, s.value = v;
        else {
          const L = -P, $ = Math.max(0, -P / 2), q = -X, ne = Math.max(0, -X / 2);
          t.value = le(p, L, $), s.value = le(v, q, ne);
        }
      }
    });
  })(), g = (() => {
    const t = T(1);
    return C({
      get() {
        return t.value;
      },
      set(s) {
        t.value = le(s, d.value, u.value);
      }
    });
  })(), M = (() => {
    const t = T(0);
    return C({
      get() {
        return t.value;
      },
      set(s) {
        t.value = s;
      }
    });
  })(), b = C(() => g.value * S.value), _ = C(() => [e.value.left + Y.value[0], e.value.top + Y.value[1]]), O = C(() => M.value), z = T(!1), H = T(0.3);
  let D = !1;
  function A(t, s, p, v = !1) {
    const P = B(t, s, p, 0);
    g.value = t, Y.value = P, z.value = v, D = !0, _e(() => {
      D = !1;
    }), setTimeout(() => {
      z.value = !1;
    }, H.value * 1e3);
  }
  J([O, b, _], () => {
    D || (z.value = !1);
  });
  function V(t, s, p) {
    const v = B(t, [0.5, 0.5], [0.5, 0.5], 0), P = [
      e.value.left + v[0] + o.value * (t * S.value) * 0.5,
      e.value.top + v[1] + a.value * (t * S.value) * 0.5
    ], X = F(0.5, 0.5, t, s, p), L = X[0] - P[0], $ = X[1] - P[1];
    return [L, $];
  }
  function I() {
    const t = V(g.value, [0, 0], M.value);
    return {
      x: de(Y.value[0] + t[0], 6),
      y: de(Y.value[1] + t[1], 6),
      scale: de(g.value, 6),
      rotate: de(De(M.value), 6)
    };
  }
  const K = C({
    get() {
      return I();
    },
    set(t) {
      const s = I();
      if (t.x === s.x && t.y === s.y && t.scale === s.scale && t.rotate === s.rotate)
        return;
      const p = Ae(t.rotate), v = V(t.scale, [0, 0], p);
      Y.value = [t.x - v[0], t.y - v[1]], g.value = t.scale, M.value = p;
    }
  });
  function W(t, s) {
    return [t - x.value, s - R.value];
  }
  function N(t, s) {
    const [p, v] = W(t, s);
    return [p / m.value, v / y.value];
  }
  function G(t, s) {
    const p = [0, 0], v = [t - Y.value[0], s - Y.value[1]], P = fe(v, p, -M.value), X = [P[0] / b.value, P[1] / b.value];
    return [X[0] / o.value, X[1] / a.value];
  }
  function k(t, s) {
    const p = W(t, s);
    return G(p[0], p[1]);
  }
  function ee(t, s) {
    const [p, v] = k(t, s);
    return [p * o.value, v * a.value];
  }
  function F(t, s, p, v, P) {
    p = p != null ? p : g.value, v = v != null ? v : Y.value, P = P != null ? P : M.value;
    const X = [e.value.left, e.value.top], L = [
      e.value.left + o.value * (p * S.value) * t,
      e.value.top + a.value * (p * S.value) * s
    ], $ = fe(L, X, P);
    return [$[0] + v[0], $[1] + v[1]];
  }
  function U(t, s) {
    const p = t / o.value, v = s / a.value;
    return F(p, v);
  }
  function B(t, s, p, v) {
    const P = o.value * S.value, X = a.value * S.value, L = p[0] * P * t, $ = p[1] * X * t, q = fe([L, $], [0, 0], v != null ? v : M.value), ne = s[0] * m.value, ge = s[1] * y.value, ye = ne - q[0], ze = ge - q[1];
    return [ye, ze];
  }
  function Z(t, s, p) {
    const v = p, P = V(g.value, [0, 0], v), X = [0 - P[0], 0 - P[1]], L = g.value, q = F(t, s, L, X, v), ne = F(t, s), ge = ne[0] - q[0], ye = ne[1] - q[1];
    Y.value = [X[0] + ge, X[1] + ye], M.value = v;
  }
  const { handleTouchend: te, handleTouchmove: re, handleTouchstart: ue } = et({
    wrapperInnerWidth: m,
    wrapperInnerHeight: y,
    canvasNaturalWidth: o,
    canvasNaturalHeight: a,
    translate: Y,
    rotate: M,
    scale: g,
    offset: e,
    rotationEnabled: r,
    minScale: d,
    maxScale: u,
    naturalScale: S,
    clientCoordsToWrapperCoords: W,
    getCanvasCoords: G,
    calcProjectionTranslate: B
  }), { handleWheel: ce } = tt({
    scale: g,
    translate: Y,
    minScale: d,
    maxScale: u,
    relativeWrapperCoordinatesFromClientCoords: N,
    normalizeMatrixCoordinates: k,
    calcProjectionTranslate: B
  }), { handleMousedown: he, handleMouseup: se, handleMousemove: me } = nt(Y), { handleGesturestart: ie, handleGesturechange: ve, handleGestureend: we } = ot(
    M,
    r,
    Z,
    k
  );
  return {
    handleTouchend: te,
    handleTouchmove: re,
    handleTouchstart: ue,
    handleGesturestart: ie,
    handleGesturechange: ve,
    handleGestureend: we,
    translate: Y,
    scale: g,
    rotate: M,
    renderingScale: b,
    renderingTranslate: _,
    renderingRotate: O,
    exposedTransform: K,
    rotateCanvas: Z,
    calcProjectionTranslate: B,
    clientCoordsToWrapperCoords: W,
    getCanvasCoords: G,
    normalizeMatrixCoordinates: k,
    clientCoordinatesToCanvasCoordinates: ee,
    composePoint: F,
    compose: U,
    handleWheel: ce,
    applyTransform: A,
    handleMousedown: he,
    handleMouseup: se,
    handleMousemove: me,
    wrapperBounds: w,
    transitionEnabled: z,
    transitionDuration: H,
    wrapperX: c,
    wrapperY: h,
    wrapperWidth: l,
    wrapperHeight: f
  };
}
const rt = /* @__PURE__ */ Ge({
  __name: "Zoompinch",
  props: {
    transform: { default: () => ({ x: 0, y: 0, scale: 1, rotate: 0 }) },
    width: {},
    height: {},
    offset: { default: () => ({ left: 0, top: 0, right: 0, bottom: 0 }) },
    maxScale: { default: 10 },
    minScale: { default: 0.5 },
    bounds: { type: Boolean, default: !1 },
    rotation: { type: Boolean, default: !0 },
    mouse: { type: Boolean, default: !0 },
    wheel: { type: Boolean, default: !0 },
    touch: { type: Boolean, default: !0 },
    gesture: { type: Boolean, default: !0 }
  },
  emits: ["update:transform"],
  setup(n, { expose: o, emit: a }) {
    const e = n, i = a, r = T(), d = T(), u = T(), c = oe(e, "width"), h = oe(e, "height"), l = oe(e, "offset"), f = C(() => !e.bounds && e.rotation), {
      renderingTranslate: w,
      renderingRotate: x,
      renderingScale: R,
      composePoint: m,
      handleWheel: y,
      handleMousedown: j,
      handleMousemove: Q,
      handleMouseup: S,
      handleTouchstart: Y,
      handleTouchmove: g,
      handleTouchend: M,
      handleGesturestart: b,
      handleGesturechange: _,
      handleGestureend: O,
      applyTransform: z,
      rotateCanvas: H,
      compose: D,
      exposedTransform: A,
      calcProjectionTranslate: V,
      clientCoordinatesToCanvasCoordinates: I,
      normalizeMatrixCoordinates: K,
      transitionEnabled: W,
      transitionDuration: N,
      wrapperX: G,
      wrapperY: k,
      wrapperWidth: ee,
      wrapperHeight: F
    } = at({
      wrapperElementRef: r,
      canvasNaturalWidth: c,
      canvasNaturalHeight: h,
      offset: l,
      bounds: oe(e, "bounds"),
      rotationEnabled: f,
      minScale: oe(e, "minScale"),
      maxScale: oe(e, "maxScale")
    });
    J(A, () => {
      (e.transform.rotate !== A.value.rotate || e.transform.scale !== A.value.scale || e.transform.x !== A.value.x || e.transform.y !== A.value.y) && i("update:transform", A.value);
    }), J(
      () => e.transform,
      () => {
        A.value = {
          x: e.transform.x,
          y: e.transform.y,
          scale: e.transform.scale,
          rotate: e.transform.rotate
        };
      },
      { deep: !0 }
    ), xe(() => {
    });
    const U = (t) => {
      if (e.wheel) {
        const s = Oe(t);
        console.log("isTrackpad", s), y(t);
      }
    }, B = (t) => {
      e.touch && Y(t);
    }, Z = (t) => {
      e.touch && g(t);
    }, te = (t) => {
      e.touch && M(t);
    }, re = (t) => {
      e.mouse && j(t);
    }, ue = (t) => {
      e.mouse && Q(t);
    }, ce = (t) => {
      e.mouse && S(t);
    };
    function he() {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    }
    const se = C(() => !he() && e.gesture), me = (t) => {
      se.value && b(t);
    }, ie = (t) => {
      se.value && _(t);
    }, ve = (t) => {
      se.value && O(t);
    };
    window.addEventListener("touchmove", Z), window.addEventListener("touchend", te), window.addEventListener("mouseup", ce), window.addEventListener("mousemove", ue), window.addEventListener("gesturechange", ie), window.addEventListener("gestureend", ve), ke(() => {
      window.removeEventListener("touchmove", Z), window.removeEventListener("touchend", te), window.removeEventListener("mouseup", ce), window.removeEventListener("mousemove", ue), window.removeEventListener("gesturechange", ie), window.removeEventListener("gestureend", ve);
    });
    const we = C(() => ({
      x: G.value,
      y: k.value,
      width: ee.value,
      height: F.value
    }));
    return o({
      compose: D,
      composePoint: m,
      clientCoordinatesToCanvasCoordinates: I,
      normalizeMatrixCoordinates: K,
      applyTransform: z,
      calcProjectionTranslate: V,
      rotateCanvas: H,
      wrapperBounds: we,
      canvas: d,
      matrix: u
    }), (t, s) => (Be(), $e("div", {
      ref_key: "zoompinchRef",
      ref: r,
      class: je(["zoompinch", {
        "transition-enabled": E(W)
      }]),
      style: Ie({
        "--canvas-width": `${t.width}px`,
        "--canvas-height": `${t.height}px`,
        "--canvas-ratio": t.width / t.height,
        "--rendering-scale": E(R),
        "--translate-x": `${E(w)[0]}px`,
        "--translate-y": `${E(w)[1]}px`,
        "--rotate": `${E(De)(E(x))}deg`,
        "--offset-top": `${e.offset.top}px`,
        "--offset-right": `${e.offset.right}px`,
        "--offset-bottom": `${e.offset.bottom}px`,
        "--offset-left": `${e.offset.left}px`,
        "--transition-duration": `${E(N)}s`
      }),
      onWheel: U,
      onTouchstart: B,
      onMousedown: re,
      onGesturestart: me
    }, [
      Ce("div", {
        ref_key: "canvasRef",
        ref: d,
        class: "canvas"
      }, [
        Re(t.$slots, "canvas", {}, void 0, !0)
      ], 512),
      Ce("div", {
        ref_key: "matrixRef",
        ref: u,
        class: "matrix"
      }, [
        Re(t.$slots, "matrix", {
          composePoint: E(m),
          compose: E(D),
          clientCoordinatesToCanvasCoordinates: E(I),
          normalizeMatrixCoordinates: E(K)
        }, void 0, !0)
      ], 512)
    ], 38));
  }
});
const st = (n, o) => {
  const a = n.__vccOpts || n;
  for (const [e, i] of o)
    a[e] = i;
  return a;
}, ut = /* @__PURE__ */ st(rt, [["__scopeId", "data-v-0c798462"]]);
export {
  ut as Zoompinch
};
